import { genReplaceEmpty } from '../../../utils/helper'
import { GrupoUnidadMedidaInputProps } from '../interfaces'

/**
 * Componemos los datos del grupo de unidad de medida desde la respuesta de la API al formato
 * que espera el formulario para la actualización
 *
 * @param input Objeto de grupo de unidad de medida desde la API
 * @returns Objeto transformado para el formulario
 */
export const grupoUnidadMedidaActualizarComposeService = (
  input: any,
): GrupoUnidadMedidaInputProps => {
  // Extraemos el código de la unidad de medida base desde el objeto anidado
  const codigoUnidadMedidaBase = input.unidadMedidaBase?.codigoUnidadMedida || ''

  // Transformamos la definición, conservando las claves necesarias
  const definicion =
    input.definicion?.map((def: any) => ({
      // Generamos un ID temporal para el manejo en el formulario si no existe
      id: def.id || `temp-${Math.random().toString(36).substr(2, 9)}`,
      // Extraemos el código de la unidad de medida desde el objeto anidado
      codigoUnidadMedida: def.unidadMedida?.codigoUnidadMedida || '',
      // Conservamos la cantidad base
      cantidadBase: def.cantidadBase || 0,
      // Conservamos la unidad de medida completa para referencias en el UI
      unidadMedida: def.unidadMedida || null,
    })) || []

  return {
    //@ts-ignore
    _id: input._id, // Aseguramos que el ID se conserve
    nombreGrupo: genReplaceEmpty(input.nombreGrupo, ''),
    codigoUnidadMedidaBase,
    definicion,
  }
}
